module.exports = __webpack_public_path__ + "static/media/ichiban-shushi.0dedf0ad.png";